export const ADD_FORM = "add_uen_form";
export const SEARCH_FORM = "search_uen_form";

export const PAGE_COUNT = 200;
